import { useState } from 'react';
import Field from '/src/components/UI/Field/Field';
import "./DashboardVariableFormModal.css"
import Slider, { Slide, ScrollIntoSlide } from '/src/components/slider/sliderView';
import { useState } from 'react';
import IconButton from '/src/components/UI/Button/IconButton/IconButton';
import "../../DashboardEditor/DashboardEditor.css";
import DashboardBlockVariableCondition from "./DashboardBlockVariableCondition";
import '../../DashboardForm/DashboardForm.css';
import generateKey from '/src/utils/generateKey';
const DashboardVariableFormConditionalsSlide = ({ hookBlocks }) => {

    const { listBlockConditions, modifyBlockConditions, createBlockCondition, getConditionsByBlock, createCondition, getVariables } = hookBlocks

    const [currentVariable, setCurrentVariable] = useState(null);

    return (
        <>
            <div className={"container_conditional_block"}>
                <div className="information_message" style={{ marginTop: "20px", marginBottom: "20px", width: "85%" }}>
                    <i className="fas fa-info-circle" style={{ marginRight: "15px" }}></i>
                    Set here any condition that is mandatory for your new variable to appear for the user
                </div>
                { /*  BLOCK d'ajout des variables conditionnelles */}
                <div style={{ display: "flex", alignItems: "center" }}>
                    <Field label="Add a new block condition" listLabelClassName="field-modal"></Field>
                    <div style={{ display: 'flex', justifyContent: "center" }}>
                        <IconButton id={"button_add_block_condition"} className="main-iconButton add-hover modalButtons-input" icon="fas fa-plus-circle" onClick={() => createBlockCondition()} />
                    </div>
                </div>

                <div className="divider div-transparent div-dot" style={{ marginTop: currentVariable == null ? "30px" : "" }}></div>
                {
                    listBlockConditions != null && listBlockConditions.length > 0 &&
                    <>
                        <Field label="List of conditions" listLabelClassName="field-modal"></Field>
                        <br />
                    </>
                }
                {
                    listBlockConditions.map((block, i) => {
                        let _conditions = getConditionsByBlock(block.index);
                        return (
                            <div key={generateKey()}>
                                {i != 0 && <div style={{ textAlign: "center", color: "var(--main)", marginBottom: "15px", marginTop: "15px" }}> AND </div>}
                                <DashboardBlockVariableCondition hookBlocks={hookBlocks} variables={getVariables()} conditions={_conditions} block={block} setListConditions={modifyBlockConditions} createCondition={() => createCondition(block.index)} />
                            </div>
                        )
                    })
                }
            </div >


            <div style={{ display: 'flex', justifyContent: "space-between" }}>
                <div className="dashboard_advanced_parameters" onClick={() => ScrollIntoSlide("advanced")}> <i className="fas fa-arrow-left" style={{ marginRight: "10px", marginTop: "0" }}></i>Advanced Parameters</div>
            </div>


        </>
    )
}
export default DashboardVariableFormConditionalsSlide 
